// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609161758/js/" + chunkId + "." + {"44":"8b1bc9d9","225":"50b4014d","481":"27513623","486":"62859b0d","770":"960f7278"}[chunkId] + ".0.6471513870371648.chunk.js";
};